/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 8BlIXCfTLl3k

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { RawTbody } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawTable/Tbody"; // plasmic-import: F53yG4ccaMWs/codeComponent
import TableTr from "../../TableTr"; // plasmic-import: ClRepu2PwVaX/component
import TableTd from "../../TableTd"; // plasmic-import: yk0RhbxcMVQJ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicTableTbody.module.css"; // plasmic-import: 8BlIXCfTLl3k/css

createPlasmicElementProxy;

export type PlasmicTableTbody__VariantMembers = {};
export type PlasmicTableTbody__VariantsArgs = {};
type VariantPropType = keyof PlasmicTableTbody__VariantsArgs;
export const PlasmicTableTbody__VariantProps = new Array<VariantPropType>();

export type PlasmicTableTbody__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicTableTbody__ArgsType;
export const PlasmicTableTbody__ArgProps = new Array<ArgPropType>("children");

export type PlasmicTableTbody__OverridesType = {
  root?: Flex__<typeof RawTbody>;
};

export interface DefaultTableTbodyProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTableTbody__RenderFunc(props: {
  variants: PlasmicTableTbody__VariantsArgs;
  args: PlasmicTableTbody__ArgsType;
  overrides: PlasmicTableTbody__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <RawTbody
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <TableTr
            className={classNames("__wab_instance", sty.tableTr__osIMv)}
          />
        ),

        value: args.children
      })}
    </RawTbody>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof RawTbody;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTableTbody__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTableTbody__VariantsArgs;
    args?: PlasmicTableTbody__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicTableTbody__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTableTbody__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTableTbody__ArgProps,
          internalVariantPropNames: PlasmicTableTbody__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTableTbody__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTableTbody";
  } else {
    func.displayName = `PlasmicTableTbody.${nodeName}`;
  }
  return func;
}

export const PlasmicTableTbody = Object.assign(
  // Top-level PlasmicTableTbody renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicTableTbody
    internalVariantProps: PlasmicTableTbody__VariantProps,
    internalArgProps: PlasmicTableTbody__ArgProps
  }
);

export default PlasmicTableTbody;
/* prettier-ignore-end */
